import styled from 'styled-components';

export const CropImage_Layout = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
